<script setup>
import {computed} from "vue";
import {game} from "@/utils/config";
import {kaoajiangStores, searchArea, searchCity} from "@/utils/module/kaojiang";
import router from "@/router";

const type = computed(() => game.kaojiang)
const data = computed(() => kaoajiangStores)
const city = computed(() => searchCity.map(its=> {return {text:its,value:its}}))
const area = computed(() => searchArea.map(its=> {return {text:its,value:its}}))
const filterHandler = (value, row, column) => {
  const property = column['property'];
  return row[property] === value;
}
</script>

<template>
  <div :style="type.style" class="page-stores">
    <div class="stores-header">
      <div class="back" @click="router.replace({name:'home'})">
        <el-icon>
          <ArrowLeft/>
        </el-icon>
      </div>
      <div class="title">烤匠代金券适用门店</div>
      <div></div>
    </div>
    <el-table stripe border :data="data" height="90vh" size="small">
      <el-table-column label="门店名称" prop="name"/>
      <el-table-column label="城市" prop="city" :filters="city" :filter-method="filterHandler"/>
      <el-table-column label="地区" prop="area" :filters="area" :filter-method="filterHandler"/>
      <el-table-column label="地址" prop="address"/>
      <el-table-column label="联系电话" prop="tel"/>
    </el-table>
  </div>
</template>

<style scoped lang="less">
.page-stores {
  background-color: #F3EBDD;
  height: 100vh;

  .stores-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 45px;
    box-sizing: border-box;
    padding: 0 15px;
  }
}
</style>
